__turbopack_context__.v({
  "directions": "StoreInformation-module-scss-module__Zp1v9a__directions",
  "directionsLink": "StoreInformation-module-scss-module__Zp1v9a__directionsLink",
  "screenReader": "StoreInformation-module-scss-module__Zp1v9a__screenReader",
});
